import { Plugin } from '../Plugin';
import flatpickr from 'flatpickr';
import confirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate';
import { German } from 'flatpickr/dist/l10n/de.js';

const NAME = 'flatpickr';
const flatpickrLanguages = {
  de: German
};

class Flatpickr extends Plugin {
  getName() {
    return NAME;
  }

  static getDefaults() {
    return {
      defaultHour: 0,
      defaultMinute: 0,
      time_24hr: true,
      weekNumbers: true,
      plugins: [new confirmDatePlugin({showAlways: true})]
    };
  }

  render() {
    if (typeof flatpickr === 'undefined') {
      return;
    }

    const data = this.$el.data();
    if (data.hasOwnProperty('language') && flatpickrLanguages.hasOwnProperty(data.language)) {
      this.options.locale = flatpickrLanguages[data.language];
    }

    if (data.hasOwnProperty('inFuture') && data.inFuture === true && !data.hasOwnProperty('minDate')) {
      this.options.minDate = new Date();
    }

    if (data.hasOwnProperty('inPast') && data.inPast === true && !data.hasOwnProperty('maxDate')) {
      this.options.maxDate = new Date();
    }

    if (data.hasOwnProperty('disableDates') && typeof data.disableDates === 'object') {
      this.options.disable = JSON.parse(this.$el.attr('data-disable-dates'));
    }

    this.removeCustomOptions();
    flatpickr(this.$el.get(0), this.options);
  }

  removeCustomOptions() {
    delete this.options.language;
    delete this.options.inFuture;
    delete this.options.inPast;
    delete this.options.disableDates;
  }
}

Plugin.register(NAME, Flatpickr);

export default Flatpickr;
